module.exports = __webpack_public_path__ + "static/media/upgrade-vps-mobile.1df0b869.png";